<style>
.fc-event-time, .fc-daygrid-event-dot {
  display:none;
}
</style>
<template>
  <section class="tables">
    <vue-snotify></vue-snotify>
    <!-- Bootstrap Model -->
    <div>
      <b-modal id="modal" :title="modalTitle" ref="calendar-modal" @ok.prevent="addRSVP" @hidden="resetModal">
        <div class="row">
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-3">Title</div>
              <div class="col-md-9">
                <b-form-group label-for="Active">
                  <b-form-select v-model="rsvpData.name" :options="allModules" class="mb-3" value-field="val"
                    text-field="option" disabled-field="notEnabled" style="margin-bottom: 0px !important;">
                  </b-form-select>
                  <span v-if="$v.rsvpData.name.$error" class=" text-danger error-message">
                    This is a required field.
                  </span>
                </b-form-group>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-3">Start Time</div>
              <div class="col-md-9">
                <div role="group" class="form-group">
                  <input v-model="rsvpData.startTime" type="time" class="form-control">
                  <span v-if="$v.rsvpData.startTime.$error" class=" text-danger error-message">
                    This is a required field.
                  </span>
                </div>
                
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-3">End Time</div>
              <div class="col-md-9">
                <div role="group" class="form-group">
                  <input v-model="rsvpData.EndTime" type="time" class="form-control">
                  <span v-if="$v.rsvpData.EndTime.$error" class=" text-danger error-message">
                    This is a required field.
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-3">Venue</div>
              <div class="col-md-9">
                <b-form-group label-for="Active">
                  <b-form-select v-model="rsvpData.location" :options="allVenues" class="mb-3" value-field="val"
                    text-field="option" disabled-field="notEnabled" style="margin-bottom: 0px !important;">
                  </b-form-select>
                  <span v-if="$v.rsvpData.location.$error" class=" text-danger error-message">
                    This is a required field.
                  </span>
                </b-form-group>
              </div>
            </div>
          </div>
          <b-button v-if="isEditing" variant="danger" @click="confirmDelete">Delete</b-button>
        </div>
      </b-modal>
    </div>
    <!--X Bootstrap Model X-->

    <div class="row">
      <div class="col-lg-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Calendar</h4>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-12">
                <FullCalendar v-model="rsvpData.date" :options="calendarOptions" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </section>
</template>

<script>
import Vue from "vue";
import API from '@/api'
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import moment from 'moment'
import FullCalendar from '@fullcalendar/vue'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'

export default {
  name: 'calendar',
  mixins: [validationMixin],
  data() {
    return {
      calendarOptions: {
        plugins: [dayGridPlugin, interactionPlugin],
        initialView: 'dayGridMonth',
        selectable: true,
        select: this.selectDate,
        selectMirror: true,
        headerToolbar: {
          left: "prev,next today",
          right: "title",
          center: ""
        },
        events: [],
        eventClick: this.editEvent,
      },
      allVenues: [
        {
          val: "",
          option: "-- Select a Venue --",
          venue: "-- Select a Venue --",
          valV: ""
        }
      ],
      allModules: [
        {
          val: "",
          option: "-- Select a Module --",
          venue: "-- Select a Venue --",
          valV: ""
        }
      ],
      rsvpData: {
        name: "",
        startTime: "",
        EndTime: "",
        location: "",
        start: "",
        end: "",
        editingEventId:"",
      },
      modalTitle: 'Add Seminar',
      isEditing: false,
      // editingEventId: null,
    }
  },
  validations: {
    rsvpData: {
      name: {
        required
      },
      startTime: {
        required
      },
      EndTime: {
        required
      },
      location: {
        required
      }
    }
  },
  methods: {
    getAllModules() {
      API.getAllModules(res => {
        res.data.forEach(element => {
          this.allModules.push({
            val: element.ModuleName,
            option: element.ModuleName,
            venue: element.ModuleVenue,
            valV: element.ModuleVenue,
          });
        });
      },
        this.errorCB)
    },
    getAllVenues() {
      API.getAllVenues(res => {
        res.data.forEach(element => {
          this.allVenues.push({
            val: element,
            option: element,
            venue: element,
            valV: element,
          });
        });
      },
        this.errorCB)
    },
    getAllEvents() {
      API.getAllEvents(res => {
        res.data.forEach(event => {
          this.calendarOptions.events.push({
            id: event.id,
            title: event.name,
            start: event.start,
            end: event.end, // Add 1 day to include the end day
            location: event.location, // Add 1 day to include the end day
            st: event.startTime, // Add 1 day to include the end day
            et: event.EndTime, // Add 1 day to include the end day
          });
        });
      }, this.errorCB);
    },
    editEvent(info) {
      // Open the modal for editing
      this.$refs['calendar-modal'].show();

      // Populate the modal with event details
      this.modalTitle = 'Edit Seminar';
      this.rsvpData.editingEventId = info.event.id;
      console.log(this.rsvpData.editingEventId);
      this.rsvpData.name = info.event.title;
      // this.rsvpData.start = info.event.start;
      // this.rsvpData.end = moment(info.event.end).add(1, 'day').format('YYYY-MM-DD') ;
      // this.rsvpData.startTime = moment(info.event.extendedProps.st).format('HH:mm');
      this.rsvpData.startTime = moment(info.event.extendedProps.st, 'HH:mm').format('HH:mm');
      this.rsvpData.EndTime = moment(info.event.extendedProps.et, 'HH:mm').format('HH:mm');
      console.log(this.rsvpData.startTime,this.rsvpData.EndTime);
      this.rsvpData.location = info.event.extendedProps.location; // Set this to the appropriate field from your event data
      this.isEditing = true;
    },

    addRSVP() {
      console.log(this.rsvpData); // Add this line to check if the method is called

      this.$v.rsvpData.$touch();
      if (this.$v.rsvpData.$anyError) {
        return;
      }

      if (this.isEditing) {
        API.editRsvp(this.rsvpData, data => {
          this.$refs['calendar-modal'].hide();
          this.$showNotification({ message: data.data.message }, "success");
          this.getAllEvents();
          this.rsvpData = {
                name: '',
                startTime: '',
                EndTime: '',
                location: '',
                start: '',
                end: '',
                editingEventId: '',
              };

          this.isEditing = false;
          this.modalTitle = 'Add Seminar';
          this.$v.$reset();
        }, this.errorCB);
      } else {
        API.addRsvp(this.rsvpData, data => {
          this.$refs['calendar-modal'].hide();
          this.$showNotification({ message: data.data.message },  "success");
          this.getAllEvents();
          // Reset the form data and flags
          this.rsvpData = {
            name: '',
            startTime: '',
            EndTime: '',
            location: '',
            start: '',
            end: '',
            editingEventId: '',
          };
          this.$v.$reset();
          // this.editingEventId = null;
          this.modalTitle = 'Add Seminar'; // Reset the modal title
        }, this.errorCB);
      }

    },
    resetModal() {
      this.rsvpData = {
            name: '',
            startTime: '',
            EndTime: '',
            location: '',
            start: '',
            end: '',
            editingEventId: '',
          };
          this.isEditing = false;
          this.modalTitle = 'Add Seminar';
          this.$v.$reset();
    },
    selectDate(arg) {
      this.rsvpData.start = arg.startStr;
      this.rsvpData.end = this.getPreviousDay(new Date(arg.endStr))
      this.$refs['calendar-modal'].show();
    },
    getPreviousDay(date = new Date()) {
      const previous = new Date(date.getTime());
      previous.setDate(date.getDate() - 1);
      return moment(previous).format('YYYY-MM-DD');
    },
    errorCB(err) {
      console.log(err);
      this.$showNotification(err, "error")
    },
    confirmDelete() {
      // Show a confirmation modal or prompt here
      if (confirm('Are you sure you want to delete this event?')) {
        // Call the API to delete the RSVP
        API.deleteRsvp(this.rsvpData.editingEventId, data => {
            this.$refs['calendar-modal'].hide();
            this.$showNotification({ message: data.data.message }, "success");
            this.getAllEvents();
            location.reload(true);
          }, this.errorCB);
      }
    },
  },
  mounted() {
    this.getAllModules();
    this.getAllEvents();
    this.getAllVenues();
  },
  components: { FullCalendar }
}

</script>